import { Footer } from "../components/footer/footer";
import { Scroll } from "../components/scroll/scroll";
import { Header } from "../components/header/header";
import { Button } from "../components/button/button";
import { useI18n } from "../i18n";
import "./tools.scss";

const TOOLS = [
  {
    id: "qrcode",
    route: "/tools/qrcode",
    icon: (
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="8" height="8" rx="1" />
        <rect x="14" y="2" width="8" height="8" rx="1" />
        <rect x="2" y="14" width="8" height="8" rx="1" />
        <rect x="14" y="14" width="4" height="4" rx="0.5" />
        <rect x="20" y="14" width="2" height="2" rx="0.25" />
        <rect x="14" y="20" width="2" height="2" rx="0.25" />
        <rect x="20" y="20" width="2" height="2" rx="0.25" />
      </svg>
    ),
    titleKey: "qrCode" as const,
    descKey: "qrCodeDesc" as const,
  },
  {
    id: "password",
    route: "/tools/password",
    icon: (
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        <circle cx="12" cy="16" r="1" />
      </svg>
    ),
    titleKey: "password" as const,
    descKey: "passwordDesc" as const,
  },
];

export default function Tools() {
  const { translations } = useI18n();

  return (
    <Scroll>
      <main className="page">
        <Header
          title={translations.tools.nav}
          breadcrumbs={[
            { label: "GAraujo", href: "/" },
            { label: translations.tools.nav, href: "/tools" },
          ]}
        />
        <div className="content">
          <section className="tools-grid">
            {TOOLS.map((tool) => (
              <Button
                key={tool.id}
                to={tool.route}
                variant="ghost"
                size="lg"
                className="tools-card"
              >
                <div className="tools-card__icon">{tool.icon}</div>
                <h3 className="tools-card__title">
                  {translations.tools[tool.titleKey]}
                </h3>
                <p className="tools-card__desc">
                  {translations.tools[tool.descKey]}
                </p>
              </Button>
            ))}
          </section>
        </div>
        <Footer />
      </main>
    </Scroll>
  );
}
